// console.log('loading scroll script');
if ('scrollRestoration' in history) {
    history.scrollRestoration = 'manual'
}

document.addEventListener('DOMContentLoaded', function () {
    const preventScrollRestoration = sessionStorage.getItem('preventScrollRestoration') === 'true' ? true :  false;
    // console.log('checking for preventScrollRestoration: ', preventScrollRestoration)
    window.addEventListener('unload', function() {
            // Save the scroll position
            // console.log('Saving scroll position');
            const scrollPosition = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
            sessionStorage.setItem("scrollPosition", scrollPosition);
    });

    // Load the scroll position, if it exists
    if(!preventScrollRestoration) {
        // Using setTimeout to ensure this runs after other document load events
        // console.log('getting scroll position');
        const scrollPosition = sessionStorage.getItem("scrollPosition");
        if(scrollPosition) {
            setTimeout(function() {
                // console.log('scrolling to position...');
                window.scrollTo(0, parseInt(sessionStorage.getItem("scrollPosition")));
            }, 0);
        }
    }

    sessionStorage.setItem('preventScrollRestoration', false);
});
